var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawerAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 29,
    fill: "#EB5757",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0074 14.7551L11.1849 39.5001C10.8792 40.0293 10.7175 40.6294 10.7158 41.2405C10.7141 41.8517 10.8725 42.4526 11.1751 42.9835C11.4777 43.5145 11.9141 43.9569 12.4408 44.2668C12.9676 44.5768 13.5663 44.7434 14.1774 44.7501H43.8224C44.4335 44.7434 45.0321 44.5768 45.5589 44.2668C46.0856 43.9569 46.522 43.5145 46.8246 42.9835C47.1272 42.4526 47.2856 41.8517 47.2839 41.2405C47.2822 40.6294 47.1205 40.0293 46.8149 39.5001L31.9924 14.7551C31.6804 14.2408 31.2411 13.8156 30.7169 13.5205C30.1928 13.2253 29.6014 13.0703 28.9999 13.0703C28.3983 13.0703 27.8069 13.2253 27.2828 13.5205C26.7586 13.8156 26.3193 14.2408 26.0074 14.7551V14.7551Z",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23.75V30.75",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37.75H29.0162",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerAlert);
export default __webpack_public_path__ + "static/media/drawer_alert.f88e5eb29e39b6dfb43b0c826444937a.svg";
export { ForwardRef as ReactComponent };